import { render, staticRenderFns } from "./TrailModeBook.vue?vue&type=template&id=3b95c071&scoped=true&"
import script from "@/scripts/TrailMode/TrailModeBook/index.js?vue&type=script&lang=js&"
export * from "@/scripts/TrailMode/TrailModeBook/index.js?vue&type=script&lang=js&"
import style0 from "./TrailModeBook.vue?vue&type=style&index=0&id=3b95c071&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b95c071",
  null
  
)

export default component.exports